/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Status_SubmittedInputs */

const en_embed_captions_status_submitted = /** @type {(inputs: Embed_Captions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submitted`)
};

const fr_embed_captions_status_submitted = /** @type {(inputs: Embed_Captions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumis`)
};

const de_embed_captions_status_submitted = /** @type {(inputs: Embed_Captions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingereicht`)
};

const it_embed_captions_status_submitted = /** @type {(inputs: Embed_Captions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inviato`)
};

const ru_embed_captions_status_submitted = /** @type {(inputs: Embed_Captions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поданный`)
};

const es_embed_captions_status_submitted = /** @type {(inputs: Embed_Captions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado`)
};

const zh_cn2_embed_captions_status_submitted = /** @type {(inputs: Embed_Captions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已提交`)
};

const ja_embed_captions_status_submitted = /** @type {(inputs: Embed_Captions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提出済み`)
};

const hi_embed_captions_status_submitted = /** @type {(inputs: Embed_Captions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रस्तुत किया गया`)
};

const pt_pt2_embed_captions_status_submitted = /** @type {(inputs: Embed_Captions_Status_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado`)
};

/**
* | output |
* | --- |
* | "Submitted" |
*
* @param {Embed_Captions_Status_SubmittedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_status_submitted = /** @type {((inputs?: Embed_Captions_Status_SubmittedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Status_SubmittedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_status_submitted(inputs)
	if (locale === "de") return de_embed_captions_status_submitted(inputs)
	if (locale === "it") return it_embed_captions_status_submitted(inputs)
	if (locale === "ru") return ru_embed_captions_status_submitted(inputs)
	if (locale === "es") return es_embed_captions_status_submitted(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_status_submitted(inputs)
	if (locale === "ja") return ja_embed_captions_status_submitted(inputs)
	if (locale === "hi") return hi_embed_captions_status_submitted(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_status_submitted(inputs)
	return en_embed_captions_status_submitted(inputs)
});